import React from 'react'
import { isEqual as _isEqual } from 'lodash'

import { Dropdown, ShortcutKey, ShortcutListModal } from 'components'
import { LabDataHandler } from 'utils'
import { LabBtn } from './LabBtn'
import data from 'components/ShortcutKey/data'

class LabList extends React.PureComponent {
	constructor(props) {
		super(props);

		this.state = { filterItems: null, labBtnDropdownRef: [] }
		this.menuRef = React.createRef();
	}

	tabList = (item, key) => {
		const laboratory = item.laboratory;
		const { id, alias, title } = laboratory;
		const { currentLabID, lab/*, history*/, isMobile } = this.props;
		const isActive = id === currentLabID;
		const affiliatedPath = LabDataHandler.getLabID(laboratory);

		return (
				<div
						className={`dropdown-item${isActive ? ' active' : ''}`}
						data-laboratory-id={id}
						data-affiliated-id={id}
						data-affiliated-path={affiliatedPath}
						onClick={this.onClick}
				>
						{(alias && item.laboratory.alias !== '') ? alias : title}
						{!isMobile && <ShortcutKey id={id} lab={lab}
						// history={history}
						/>}
				</div>
		);
	}

	changeCurrent = (labID, affiliatedID, affiliatedPath) => {
		const { lab, currentLabID, history } = this.props;

		if (labID !== currentLabID.toString()) {
			const masterLabID = LabDataHandler.getLabID(lab);

			if (masterLabID !== affiliatedID) { // affiliated
				history.push('/lab/dashboard/' + masterLabID + '/' + affiliatedPath);
			} else {
				history.push('/lab/dashboard/' + masterLabID);
			}
		}
	}

	onClick = (e) => {
		const { laboratoryId, affiliatedId, affiliatedPath } = e.currentTarget.dataset;

		this.changeCurrent(laboratoryId, affiliatedId, affiliatedPath);
	}

	itemFilter = (searchValue)=>{
		const { listLabData } = this.props;
		if(searchValue!==''){
			const labs = listLabData[0]?.singles.map((item, key) => ({
				title:item.title,
				singles: item.singles.filter(d=>d.used && d.available && (d.name.toLowerCase().includes(searchValue.toLowerCase()) || d.info_short.toLowerCase().includes(searchValue.toLowerCase())))})).filter(d=>d.singles.length).map(d=>d.title);
				return labs;
		}
		return []
	}

	updateLabBtnDropdownPos = () => {
		const { labBtnDropdownRef } = this.state;

		if (this.menuRef.current) {
			const menuRect = this.menuRef.current.getBoundingClientRect();

			labBtnDropdownRef.forEach((ref) => {
				if (ref) { ref.style.top = `${menuRect.bottom - 10}px`; }
			});
		}
	}

	onChangeRef = ref => {
		if (ref) {
			this.setState((prevState) => ({
				labBtnDropdownRef: [...prevState.labBtnDropdownRef, ref]
			}));
		}
	};

	componentDidMount = () => {
		const { lab, onSearchGetRequest } = this.props;

		onSearchGetRequest(lab.id);
	}

	componentDidUpdate = (prevProps, prevState) => {
		const {lab, onSearchGetRequest, searchlistLabResult} = this.props;

		if (!_isEqual(prevProps.lab, lab)) {
			onSearchGetRequest(lab.id);
		}

		if (prevProps.searchlistLabResult !== searchlistLabResult) {
			this.setState({filterItems: [ ...searchlistLabResult ]})
		}

		const resizeObserver = new ResizeObserver(() => {
			this.updateLabBtnDropdownPos();
		});

		if (this.menuRef.current) {
			resizeObserver.observe(this.menuRef.current);
		}
	}

	onChatInputSearch = (v)=>{
		const { listLabData, onSingleSearch } = this.props;
		const labs = listLabData[0]?.singles.map((item) => ({
				name: item.title,
				tools: item.singles
					.filter((d) => (d.used && d.available))
					.map((d) => (d.name))
			})).filter((d) => (d.tools.length));

		onSingleSearch({ labs: labs, q: v });
	}

	render() {
		const { lab, currentLabID, isMobile } = this.props;
	  	const hasAffiliated = lab && lab.master 
				&& lab.master.affiliated_products.length;
	  	const isActive = lab?.id === currentLabID;
		const { filterItems } = this.state;
		const shortcutKeyData = data[lab.pathname];

	 	let items = [];

	    if (lab && lab.master) {
			items = [
				<div
					className={`dropdown-item${isActive ? ' active' : ''}`}
					data-laboratory-id={lab.id}
					data-affiliated-id={lab.id}
					data-affiliated-path={LabDataHandler.getLabID(lab)}
					onClick={this.onClick}
				>
					{(lab && lab.alias !== '') ? lab.alias : lab.title}
					
					{!isMobile && <ShortcutKey id={lab.id} lab={lab}/>}
				</div>
	        ];
	    }

	  if (hasAffiliated) {
			items = items.concat(lab.master.affiliated_products
				.map(this.tabList));
	    	items.splice(
				0,
				<div
					className={`dropdown-item${(lab.id === currentLabID) ? ' active' : ''}`}
					data-laboratory-id={lab.id}
					data-affiliated-id={lab.id}
					data-affiliated-path={LabDataHandler.getLabID(lab)}
					onClick={this.onClick}
				>
					{(lab.alias && lab.alias !== '') ? lab.alias : lab.title}

					{!isMobile && <ShortcutKey id={lab.id} lab={lab}/>}
	      		</div>
			);
		}

		return (hasAffiliated
			?
			<Dropdown
				id='lab-tab-list'
				title={<i className='menu-toggler elegant elegant-eleganticons-64' />}
	      		items={items}

		      	filterItems = {filterItems}
				filter	  = {this.itemFilter}
				searchInput
				menuRef   = {this.menuRef}
				labBtn    = { 
					<LabBtn
						renewalModalClassName='mobile'
						lab={lab}
						labID={lab?.id}
						otherData = {shortcutKeyData && !isMobile 
							? 
							{ title: '快捷鍵', id: 'shortcut-list' } 
							: 
							null
						}
						otherModal = {shortcutKeyData  
							? 
							<ShortcutListModal data={shortcutKeyData}/> 
							: 
							null}
						onChangeRef = {this.onChangeRef}
					/>}
					// onChatInputSearch = {this.onChatInputSearch}
					// isSearching={this.props.isListLabSearching}
	    	/>
			:
			null
		);
	}
}


export { LabList }
